export default "__VITE_ASSET__DZ4nHS2Y__"